<template>
  <div>
    <v-list-item
      :key="`product-${productIndex}`"
      v-for="(product, productIndex) in products"
    >
      <v-list-item-content class="py-0">
        <v-list-item-title>
          <p class="mb-1" v-if="product.lotName">
            {{ product.lotName }}
          </p>
          <div class="d-flex align-center flex-wrap">
            <p class="mb-1" style="font-weight: 700">
              {{ product[`name_${$i18n.locale}`] }}:
            </p>
            <p class="mb-1 ml-2">{{ product.count }}</p>
            <p
              class="mb-1 ml-2"
              v-if="product[`unit_type_name_${$i18n.locale}`]"
            >
              {{ product[`unit_type_name_${$i18n.locale}`].toLowerCase() }}
            </p>

            <v-btn
              :to="{
                name: 'product-history',
                query: { id: product.id },
              }"
              color=""
              class="edit_btn btn_33 ml-5"
            >
              <vue-icon icon="indexIcon"></vue-icon>
            </v-btn>
          </div>
          <v-divider class="my-2" />
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: "ProductListInWarehouse",
  props: {
    products: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>
